export class JobRequestReport {
    jobId:Number=null;
    jobTitle:string=null
    dateFrom:string=null
    dateTo:string=null
    
}
